<template>
  <v-dialog
    v-model="dialog"
    max-width="480"
    persistent
    overlay-color="#1a2744"
    overlay-opacity="0.6"
  >
    <v-card class="dialog-card" elevation="16">

      <!-- ── HEADER ── -->
      <v-card-title class="dialog-header pa-0">
        <div class="header-inner px-6 py-5 d-flex align-center">
          <div class="bell-wrap mr-4">
            <v-icon color="white" size="22">mdi-bell-ring-outline</v-icon>
          </div>
          <span class="header-title white--text">
            システムアップデートのお知らせ
          </span>
        </div>
      </v-card-title>

      <!-- ── BODY ── -->
      <v-card-text class="dialog-body px-6 pt-6 pb-2">

        <!-- Badge -->
        <div class="update-badge mb-5">
          <v-icon size="13" class="badge-icon mr-1">mdi-circle-small</v-icon>
          <span class="badge-label">Notification of System Update</span>
        </div>

        <!-- JP copy -->
        <p class="body-jp mb-2">
          セキュリティの更新、バグの修正、およびパフォーマンス向上のための新バージョンをリリースいたしました。
        </p>

        <!-- EN copy -->
        <p class="body-en mb-0">
          Release of a new version for security updates, bug fixes, and performance improvements.
        </p>

      </v-card-text>

      <!-- ── DIVIDER ── -->
      <v-divider class="mx-6 my-4 dialog-divider" />

      <!-- ── CONTACT SECTION ── -->
      <v-card-text class="px-6 pt-0 pb-5">
        <div class="contact-block pa-4">
          <div class="contact-label mb-3 d-flex align-center">
            <v-icon size="15" color="primary" class="mr-2">mdi-headset</v-icon>
            <span class="contact-label-text">お問い合わせ先 / Contact</span>
          </div>

          <!-- JP -->
          <p class="contact-jp mb-1">
            問題が発生した場合は、HRD-IHS までご連絡ください。
          </p>
          <!-- EN -->
          <p class="contact-en mb-3">
            If you encounter an issue, please contact HRD-IHS:
          </p>

          <!-- Email links -->
          <div class="email-links d-flex align-center flex-wrap">
            <a href="mailto:kenzo-takao@hrd-s.com" class="email-link">
              <v-icon size="13" class="mr-1">mdi-email-outline</v-icon>
              kenzo-takao@hrd-s.com
            </a>
            <span class="email-sep mx-2">·</span>
            <a href="mailto:sd2leaders@hrd-s.com" class="email-link">
              <v-icon size="13" class="mr-1">mdi-email-outline</v-icon>
              sd2leaders@hrd-s.com
            </a>
          </div>
        </div>
      </v-card-text>

      <!-- ── ACTIONS ── -->
      <v-card-actions class="px-6 pb-6 pt-0">
        <v-spacer />
        <v-btn
          color="primary"
          rounded
          elevation="4"
          class="confirm-btn px-6"
          @click="acknowledge"
        >
          <v-icon left size="18">mdi-check-circle-outline</v-icon>
          OK
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
const STORAGE_KEY = 'kidd_update_v2.2.1_acknowledged';

export default {
  name: 'SystemUpdateNotification',

  data() {
    return {
      dialog: false,
    };
  },

  mounted() {
    // Show only once per user session — keyed by logged-in user ID if available
    if(this.$store.state.userInfo){
      const userId = this.$store.state.userInfo.id || 'guest';
      const storageKey = `${STORAGE_KEY}_${userId}`;

      if (!localStorage.getItem(storageKey)) {
        this.dialog = true;
      }
    }
  },

  methods: {
    acknowledge() {
      const userId = this.$store.state.userInfo.id || 'guest';
      const storageKey = `${STORAGE_KEY}_${userId}`;
      localStorage.setItem(storageKey, 'true');
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
/* ── Card ── */
.dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
  font-family: 'Roboto', 'Noto Sans JP', sans-serif;
}

/* ── Header ── */
.dialog-header {
  background: linear-gradient(135deg, #1565C0 0%, #1976D2 50%, #1E88E5 100%);
  position: relative;
}

.dialog-header::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    rgba(255,255,255,0.08) 0%,
    transparent 100%
  );
  pointer-events: none;
}

.header-inner {
  width: 100%;
}

.bell-wrap {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1.5px solid rgba(255,255,255,0.3);
}

.header-title {
  font-size: 15px !important;
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 1.4;
  word-break: break-word;
  text-shadow: 0 1px 3px rgba(0,0,0,0.15);
}

/* ── Badge ── */
.update-badge {
  display: inline-flex;
  align-items: center;
  background: #E3F2FD;
  border: 1px solid #BBDEFB;
  border-radius: 20px;
  padding: 3px 10px 3px 6px;
}

.badge-icon {
  color: #1976D2 !important;
}

.badge-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #1565C0;
}

/* ── Body copy ── */
.body-jp {
  font-size: 14px;
  line-height: 1.75;
  color: #1a1a2e;
  font-weight: 500;
  margin: 0;
}

.body-en {
  font-size: 13px;
  line-height: 1.7;
  color: #555e78;
  font-weight: 400;
  margin: 0;
}

/* ── Divider ── */
.dialog-divider {
  border-color: #E8EDF7 !important;
}

/* ── Contact block ── */
.contact-block {
  background: #F5F8FF;
  border-radius: 10px;
  border: 1px solid #E3ECFB;
}

.contact-label-text {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #1976D2;
}

.contact-jp {
  font-size: 13px;
  line-height: 1.65;
  color: #2c3354;
  font-weight: 500;
  margin: 0;
}

.contact-en {
  font-size: 12px;
  line-height: 1.6;
  color: #6b7490;
  font-weight: 400;
  margin: 0;
}

/* ── Email links ── */
.email-links {
  gap: 0;
}

.email-link {
  display: inline-flex;
  align-items: center;
  font-size: 12.5px;
  font-weight: 500;
  color: #1565C0;
  text-decoration: none;
  padding: 3px 6px;
  border-radius: 5px;
  transition: background 0.18s ease, color 0.18s ease;
}

.email-link:hover {
  background: #DCEEFB;
  color: #0D47A1;
  text-decoration: underline;
}

.email-sep {
  color: #b0bdd8;
  font-size: 16px;
  user-select: none;
}

/* ── Confirm button ── */
.confirm-btn {
  font-size: 13.5px !important;
  font-weight: 600 !important;
  letter-spacing: 0.02em !important;
  height: 42px !important;
  text-transform: none !important;
  box-shadow: 0 4px 14px rgba(25, 118, 210, 0.35) !important;
  transition: box-shadow 0.2s ease, transform 0.15s ease !important;
}

.confirm-btn:hover {
  box-shadow: 0 6px 20px rgba(25, 118, 210, 0.45) !important;
  transform: translateY(-1px);
}

.confirm-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.3) !important;
}
</style>